import React from "react";
import _ from "lodash";
import { useIntl } from "react-intl";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function TripReturnableDetails({
    label,
    options,
    isReturnable,
    onChange,
    isEditable,
}) {
    const intl = useIntl();

    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                selectedValue={intl.formatMessage({ id: `misc.${isReturnable}` })}
                options={options}
                onSave={onChange}
                isEditable={isEditable}
            />
        </EuiFlexItem>
    );
}
